import Head from 'next/head';
import dynamic from 'next/dynamic';

const BrinGame = dynamic(() => import('../../components/games/BrinGame'), { ssr: false });

export default function BrinPage() {
  const url = 'https://fenkparet.com/jeux/brin';
  return (
    <>
      <Head>
        <title>Brin: Jeu de lettres quotidien en français | Fenkparet</title>
        <meta name="description" content="Brin — un jeu de lettres quotidien en français. Trouvez un maximum de mots selon le thème du jour. Un nouveau défi chaque jour !" />
        <meta name="keywords" content="brin, jeu de lettres, jeu quotidien, mots français, jeu de mots, puzzle français, strands français" />
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        <link rel="canonical" href={url} />

        {/* OpenGraph */}
        <meta property="og:title" content="Brin — Jeu de lettres quotidien | Fenkparet" />
        <meta property="og:description" content="Trouvez un maximum de mots selon le thème du jour. Un nouveau défi chaque jour en français !" />
        <meta property="og:type" content="game" />
        <meta property="og:url" content={url} />
        <meta property="og:locale" content="fr_FR" />
        <meta property="og:site_name" content="Fenkparet" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Brin — Jeu de lettres quotidien" />
        <meta name="twitter:description" content="Trouvez un maximum de mots selon le thème du jour." />

        {/* JSON-LD */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Game',
          name: 'Brin',
          description: 'Jeu de lettres quotidien — tracez des chemins dans la grille pour trouver les mots du thème du jour.',
          url,
          gamePlatform: 'Web Browser',
          genre: 'Word Game',
          numberOfPlayers: '1',
          inLanguage: 'fr',
          isAccessibleForFree: true,
          publisher: { '@type': 'Organization', name: 'Fenkparet', url: 'https://fenkparet.com' },
        }) }} />

        {/* BreadcrumbList */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://fenkparet.com' },
            { '@type': 'ListItem', position: 2, name: 'Jeux', item: 'https://fenkparet.com/jeux' },
            { '@type': 'ListItem', position: 3, name: 'Brin', item: url },
          ],
        }) }} />
      </Head>
      <BrinGame />
    </>
  );
}
